import type {RefObject} from 'react';
import {useRef} from 'react';
import {useEffect} from 'react';
import {findAndIncrementSeenTemplates, TEMPLATE_SEEN_TIMEOUT} from '@Libraries/editor-templates-library';

export function useHandleViewsAndSeenTemplateStats(gridRef: RefObject<HTMLDivElement | null>, gridItemHeight: number | null, gridItemWidth: number): void {
  const heightRef = useRef<number | null>(gridItemHeight);
  const widthRef = useRef<number>(gridItemWidth);

  const startTimerForIncrementingSeenTemplates = (): void => {
    if (gridRef.current) {
      scrollEndTimer.current = window.setTimeout(() => {
        findAndIncrementSeenTemplates(gridRef.current, heightRef.current, widthRef.current);
      }, TEMPLATE_SEEN_TIMEOUT);
    }
  };

  useEffect((): void => {
    startTimerForIncrementingSeenTemplates();
  }, []);

  useEffect((): void => {
    heightRef.current = gridItemHeight;
  }, [gridItemHeight]);

  useEffect((): void => {
    widthRef.current = gridItemWidth;
  }, [gridItemWidth]);

  const scrollEndTimer = useRef<number | undefined>();
  const scrollHandler = (): void => {
    if (scrollEndTimer.current) {
      clearTimeout(scrollEndTimer.current);
    }
  };

  const scrollEndHandler = (): void => {
    startTimerForIncrementingSeenTemplates();
  };

  useEffect(() => {
    gridRef.current?.addEventListener('scroll', scrollHandler);
    gridRef.current?.addEventListener('scrollend', scrollEndHandler);

    return (): void => {
      gridRef.current?.removeEventListener('scroll', scrollHandler);
      gridRef.current?.removeEventListener('scrollend', scrollEndHandler);
    };
  }, [gridRef.current]);
}
